import { render, staticRenderFns } from "./AddOccasionModal.vue?vue&type=template&id=200584f6&scoped=true"
import script from "./AddOccasionModal.vue?vue&type=script&lang=js"
export * from "./AddOccasionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200584f6",
  null
  
)

export default component.exports